var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"menu-list batt-swap-page"},_vm._l((_vm.menuList),function(item){return _c('bs-card-menu',{key:item.id,staticClass:"mb12",attrs:{"options":item},on:{"click":function($event){return _vm.menuDetail(item)}}})}),1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/_vue-loader@13.7.3@vue-loader/lib/template-compiler?{"id":"data-v-72694ab4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/_vue-loader@13.7.3@vue-loader/lib/selector.js?type=template&index=0!./src/components/blueshark/battswap/menu/menulist.vue
// module id = null
// module chunks = 